module.exports = __webpack_public_path__ + "b3947b5b356f21b81823bd7dd8a86cc5.svg";